import { commonConstants } from '../_constants';

export function addBeneficiary(state = {}, action) {
  switch (action.type) {
    case commonConstants.ADD_BENEFICIARY_UAE_REQUEST:
      return {
        ...state,
        addBeneficiary: true,
        data: action.addBeneficiary.data,
      };
    case commonConstants.ADD_BENEFICIARY_UAE_SUCCESS:
      return {
        ...state,
        addBeneficiary: true,
        data: action.addBeneficiary.data,
      };
    case commonConstants.ADD_BENEFICIARY_UAE_FAILURE:
      return {
        ...state,
        addBeneficiary: false,
        data: action.addBeneficiary.data,
      };
    default:
      return state;
  }
}

export function beneficary(state = {}, action) {
  switch (action.type) {
    case commonConstants.BENEFICAIRY_REQUEST:
      return {
        ...state,
        beneficiaryList: false,
        data: action.beneficiaryList.data,
      };
    case commonConstants.BENEFICAIRY_SUCCESS:
      return {
        ...state,
        beneficiaryList: true,
        data: action.beneficiaryList.data.response,
      };
    case commonConstants.BENEFICAIRY_FAILURE:
      return {
        ...state,
        beneficiaryList: false,
        data: action.beneficiaryList.data,
      };
    default:
      return state;
  }
}

export function getBankBranch(state = {}, action) {
  switch (action.type) {
    case commonConstants.BANK_BRANCH_REQUEST:
      return {
        ...state,
        getbranch: false,
        data: action.getbranch.data,
      };
    case commonConstants.BANK_BRANCH_SUCCESS:
      return {
        ...state,
        getbranch: true,
        data: action.getbranch.data.response,
      };
    case commonConstants.BANK_BRANCH_FAILURE:
      return {
        ...state,
        getbranch: false,
        data: action.getbranch.data,
      };
    default:
      return state;
  }
}

export function getAllBanks(state = {}, action) {
  switch (action.type) {
    case commonConstants.ALL_BANK_REQUEST:
      return {
        ...state,
        getbranch: false,
        data: action.getbranch.data,
      };
    case commonConstants.ALL_BANK_SUCCESS:
      return {
        ...state,
        getbranch: true,
        data: action.getbranch.data.response,
      };
    case commonConstants.ALL_BANK_FAILURE:
      return {
        ...state,
        getbranch: false,
        data: action.getbranch.data,
      };
    default:
      return state;
  }
}

export function getAllBankBranch(state = {}, action) {
  switch (action.type) {
    case commonConstants.ALL_BANK_BRANCH_REQUEST:
      return {
        ...state,
        getbranch: false,
        data: action.getbranch.data,
      };
    case commonConstants.ALL_BANK_BRANCH_SUCCESS:
      return {
        ...state,
        getbranch: true,
        data: action.getbranch.data.response,
      };
    case commonConstants.ALL_BANK_BRANCH_FAILURE:
      return {
        ...state,
        getbranch: false,
        data: action.getbranch.data,
      };
    default:
      return state;
  }
}

export function getRelationShip(state = {}, action) {
  switch (action.type) {
    case commonConstants.GET_RELATION_REQUEST:
      return {
        ...state,
        getRelation: true,
        data: action.getRelation.data,
      };
    case commonConstants.GET_RELATION_SUCCESS:
      return {
        ...state,
        getRelation: true,
        data: action.getRelation.data.response,
      };
    case commonConstants.GET_RELATION_FAILURE:
      return {
        ...state,
        getRelation: false,
        data: action.getRelation,
      };
    default:
      return state;
  }
}
